import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {
  getCategories: function({ commit }, params) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/sme-tags", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getCategoriesToSelect: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      var params = {
        filters: {
          select: true
        }
      };

      api
        .get("admin/categories", params)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getCategory: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/categories/" + data.id, {})
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  createCategory: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/sme-tags", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  deleteCategory: function({ commit }, param) {
    return new Promise((resolve, reject) => {
      api
        .delete("admin/sme-tags/" + param.id, param)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  updateCategory: function({ commit }, param) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/sme-tags/" + param.id, param)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  updateCategoryOrder: function({ commit }, param) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/sme-tags/" + param.id+'/change-order', param)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  editCategory: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/categories/" + data.id, data)
        .then(res => {
          console.log(res);
          resolve(res);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  getCategoryTags: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/categories/" + data.id + "/tags", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  addTag: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post("admin/categories/" + data.id + "/tags", data).then(res => {
        resolve(res);
      });
    }).catch(error => {
      reject(error.response);
    });
  }
};

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/CategoryModule.js